'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_SCREEN_KEY_ACTION = exports.ADD_SCREEN_KEY_ACTION = 'ADD_SCREEN_KEY_ACTION';
var REMOVE_SCREEN_KEY_ACTION = exports.REMOVE_SCREEN_KEY_ACTION = 'REMOVE_SCREEN_KEY_ACTION';

/**
 * Adds a new screenKey to stack of screenKeys
 * @param {string} screenKey 
 */
var addScreenKey = exports.addScreenKey = function addScreenKey(screenKey) {
  return {
    type: ADD_SCREEN_KEY_ACTION,
    screenKey: screenKey
  };
};

/**
 * Removes the last screenKey from the stack of screenKeys
 */
var removeScreenKey = exports.removeScreenKey = function removeScreenKey() {
  return {
    type: REMOVE_SCREEN_KEY_ACTION
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/module/actions/ScreenKeyUpdateAction.js
// module id = 746
// module chunks = 10